import { toQuoteNumberWithDashes } from 'scenes/common/helpers/quote';
import { ApiState } from 'scenes/common/types';
import { RetrieveFunnelState } from 'scenes/retrieve/types';

import { WireRetrieveFormData } from '../types';

const getPolicyNumber = (state: RetrieveFunnelState): string | undefined => {
  if (state.apiResponses.motorQuoteDetails.state === ApiState.Loaded) {
    return state.apiResponses.motorQuoteDetails.data?.payload.policy.number;
  }

  if (state.apiResponses.homeQuoteDetails.state === ApiState.Loaded) {
    return state.apiResponses.homeQuoteDetails.data?.payload.policy.number;
  }

  if (state.apiResponses.landlordQuoteDetails.state === ApiState.Loaded) {
    return state.apiResponses.landlordQuoteDetails.data?.payload.policy.number;
  }

  return undefined;
};

export const toWireFormData = (
  state: RetrieveFunnelState,
  quoteNumber?: string
): WireRetrieveFormData => ({
  quoteNumber: toQuoteNumberWithDashes(quoteNumber ?? getPolicyNumber(state)),
});
